import { UserWithCustomerResource, useGetAuthSessionQuery } from '@/api/serverApi'
import { LogoIcon, Navbar as SharedNavbar, NavItem, DesignIcon, LabelLine, BackIcon, ProfileIcon, ProjectIcon, UserIcon, useSession } from '@cfs-fixings/shared'
import { ReactNode } from 'react'
import { Link, useMatch } from 'react-router-dom'
import ProfileDropdown from './ProfileDropdown'

const UserNavigation = ({ children }: { children: ReactNode }) => {
  const { data: user } = useGetAuthSessionQuery()

  return (
    <div className="flex justify-center py-[10px]">
      <div className="flex justify-between items-center px-[26px] w-full">
        {children}
        <div className="pl-[25px]">
          <ProfileDropdown user={user?.data} />
        </div>
      </div>
    </div>
  )
}

export const MainNavigation = () => {
  const isDesigns = Boolean(useMatch('/designs/*'))
  const isProjects = Boolean(useMatch('/projects/*'))

  return (
    <>
      <LogoIcon className="w-[93px] h-[45px]" />
      <nav className="mt-10">
        <ul className="mb-[60px]">
          <NavItem
            href="/designs"
            icon={<DesignIcon className="w-[18px] h-[18px]" />}
            selected={isDesigns}
          >
            All Designs
          </NavItem>
          <NavItem
            href="/projects"
            icon={<ProjectIcon className="w-[18px] h-[18px]" />}
            selected={isProjects}
          >
            Projects
          </NavItem>
        </ul>
      </nav>
    </>
  )
}

export const SettingsNavigation = () => {
  const isProfile = Boolean(useMatch('/profile'))
  const isTeamMembers = Boolean(useMatch('/team-members'))

  const { user } : { user: { data: UserWithCustomerResource } | null } = useSession({
    getData: useGetAuthSessionQuery,
  })

  return (
    <>
      <Link
        to="/designs"
        className="flex flex-row justify-start items-center gap-[13px] mt-[22px] text-lg font-semibold leading-[21.6px]"
      >
        <BackIcon className="h-4 w-4" />
        Settings
      </Link>

      <nav className="mt-10">
        <p
          className="mb-2.5 text-gray-900 text-[13px] leading-[15.6px] flex gap-[11px] items-center font-mono uppercase"
        >
          User
          <LabelLine className="w-[31px] h-[11px]" />
        </p>
        <ul className="mb-[60px]">
          <NavItem
            href="/profile"
            icon={<ProfileIcon className="w-[17px] h-[18px]" />}
            selected={isProfile}
          >
            Profile
          </NavItem>
        </ul>
      </nav>
      {
        user?.data?.is_owner
          && (
            <nav className="mt-10">
              <p
                className="mb-2.5 text-gray-900 text-[13px] leading-[15.6px] flex gap-[11px] items-center font-mono uppercase"
              >
                Organisation
                <LabelLine className="w-[31px] h-[11px]" />
              </p>
              <ul className="mb-[60px]">
                <NavItem
                  href="/team-members"
                  icon={<UserIcon className="w-[17px] h-[18px]" />}
                  selected={isTeamMembers}
                >
                  Team Members
                </NavItem>
              </ul>
            </nav>
          )
      }
    </>
  )
}

export function Navbar ({ children, content = <MainNavigation />, topbar }: { children: ReactNode, content?: ReactNode, topbar?: ReactNode }) {
  return (
    <SharedNavbar
      sidebar={content}
      topbar={<UserNavigation>{topbar}</UserNavigation>}
    >
      {children}
    </SharedNavbar>
  )
}
